<template>
  <b-dropdown
    :id="`dropdown-${application.id}`"
    :toggle-class="'btn-default'"
    class="dropdown application-button"
    menu-class="width-max-content"
    @show="setZIndex"
    @hide="unsetZIndex"
    @dblclick.native.stop
    right
    ref="dropdown"
  >
    <template #button-content>
      <i class="fa fa-bars"/>
    </template>
    <slot name="prevItems"></slot>
    <template v-for="(item, key) in items">
      <b-dropdown-item v-if="showMenuItem(item)" :key="key" @click="actionItem(item)">
        <dropdown-image :other-icon-path="iconsPath" :icon-name="item.icon" />
        {{ item.command_name }}
      </b-dropdown-item>
    </template>
    <slot name="lastItems"></slot>
  </b-dropdown>
</template>

<script>
import actionListMenuMixin from '@/common/mixins/actionListMenuMixin'
import DropdownImage from '@/common/components/visitor/menu-components/DropdownImage.vue'

export default {
  name: 'ActionListMenu',

  components: { DropdownImage },

  mixins: [actionListMenuMixin],

  props: {
    application: Object,
    applicationIndex: {},
    approvalCommand: {
      type: Function,
      required: true
    },
    baseUrl: String,
    getSigner: {
      type: Function,
      required: true
    }
  },

  computed: {
    equalSubdivisions() {
      let applicationSubdivisionId = this.application.subdivision_id
      if (![null, undefined].includes(applicationSubdivisionId)) {
        applicationSubdivisionId = parseInt(applicationSubdivisionId)
      }

      return Boolean(this.user.subdivisions.find(subdivisionId => parseInt(subdivisionId) === applicationSubdivisionId))
    },

    iconsPath() {
      return this.baseUrl + '/img/icons/statuses/'
    },

    items() {
      return this.application.statusActions ?? []
    }
  },

  methods: {
    actionItem(item) {
      return item.esignature === '1'
        ? this.getSigner(this.application, item)
        : this.approvalCommand(this.application, item, this.applicationIndex)
    },

    hide() {
      this.$refs.dropdown?.hide()
    }
  }
}
</script>
